import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
  Space,
  DatePicker,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import { debounce } from "lodash";
import dayjs from "dayjs";
const UpdateModal = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const { onSuccess } = props; // 移除重复的 record 解构
  const [cronModalVisible, setCronModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [officeList, setOfficeList] = useState([]);
  const [emailList, setEmailList] = useState([]);
  const [loadingCron, setLoadingCron] = useState(false);
  const taskTypeKList = [
    { value: "ONCE_NOW", label: "ONCE_NOW" },
    { value: "ONCE_AT", label: "ONCE_AT" },
    { value: "CRON", label: "CRON" },
  ];
  const enabledList = [
    { value: "false", label: "OFF" },
    { value: "true", label: "ON" },
  ];

  useImperativeHandle(ref, () => ({
    showModal: async (record) => {
      try {
        console.log("Modal opening...", record);
        form.resetFields();
        setVisible(true);
        
        if (record) {
          const formValues = {
            id: record.id,
            taskName: record.taskName,
            taskKey: record.taskKey,
            taskType: record.taskType,
            enabled: record.enabled ? "true" : "false", 
            emailReceivers: Array.isArray(record.emailReceivers) 
              ? record.emailReceivers 
              : record.emailReceivers ? [record.emailReceivers] : [], 
            emailContent: record.emailContent || "",
            emailSubject: record.emailSubject || "",
          };

          if (record.runAtMillis) {
            formValues.runAtMillis = dayjs(record.runAtMillis);
          }

          if (record.cronExpression) {
            formValues.cronExpression = record.cronExpression;
          }
          if (record.cronResult) {
            formValues.cronResult = record.cronResult;
          }

          form.setFieldsValue(formValues);
        }

        await Promise.all([getTaskKeyFu(), getAccountEmailFu()]);
      } catch (error) {
        message.error("Failed to initialize modal data");
        console.error("Initialization error:", error);
      }
    },
  }));
  const getTaskKeyFu = async (search = "") => {
    try {
      const response = await http.get(api.getTaskKeyList, {
        params: { search },
      });

      if (response.code === "1") {
        const formattedOffices = response.data.map((item) => ({
          value: item,
          label: item,
        }));
        setOfficeList(formattedOffices);
      } else {
        message.error(response.msg);
      }
    } catch (error) {
      throw error;
    } finally {
    }
  };

  const getAccountEmailFu = async (search = "") => {
    try {
      const response = await http.get(api.getAccountEmailList, {
        params: { search },
      });

      if (response.code === "1") {
        const formattedEmails = response.data.map((item) => ({
          value: item.email,
          label: item.email,
        }));
        setEmailList(formattedEmails);
      } else {
        message.error(response.msg);
      }
    } catch (error) {
      message.error("Error fetching email list");
    }
  };

  const handleSearch = debounce((value) => {
    getTaskKeyFu(value);
  }, 500);

  const handleEmailSearch = debounce((value) => {
    getAccountEmailFu(value);
  }, 500);

  const handleTaskTypeChange = (value, form) => {
    if (value === "ONCE_AT") {
      // 只显示Run At.
      form.setFieldsValue({
        cronExpression: undefined,
        cronResult: undefined,
      });
    } else if (value === "CRON") {
      // 只显示Cron Expression和Cron Remark
      form.setFieldsValue({
        runAtMillis: undefined,
      });
    } else if (value === "ONCE_NOW") {
      // 都不显示
      form.setFieldsValue({
        cronExpression: undefined,
        cronResult: undefined,
        runAtMillis: undefined,
      });
    }
  };

  // 修改用户信息提交
  const onFinishAdd = async (values) => {
    try {
      setLoading(true);
      const queryParams = {
        id: values.id,
        taskName: values.taskName,
        taskKey: values.taskKey,
        taskType: values.taskType,
        cronExpression: values.cronExpression,
        runAtMillis: values.runAtMillis
          ? values.runAtMillis.valueOf()
          : undefined,
        enabled: values.enabled,
        emailList: values.emailReceivers,
        emailContent: values.emailContent,
        emailSubject: values.emailSubject,
      };
      const response = await http.post(`${api.getCronJobUpdate}`, queryParams);
      if (response.code === "1") {
        message.success("User updated successfully");
        setVisible(false);
        form.resetFields();
        onSuccess?.();
        window.location.reload();
      } else {
        message.error(response.msg || "Update failed");
      }
    } catch (error) {
      message.error(error.message || "Update failed");
    } finally {
      setLoading(false);
    }
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  const cronData = async (val) => {
    try {
      setLoadingCron(true);
      const response = await http.get(api.getCronRemark, {
        params: { cron: val },
      });
      if (response.code === "1") {
        form.setFieldsValue({ cronResult: response.data || "" });
        setLoadingCron(false);
      } else {
        message.error(response.msg);
           setLoadingCron(false);
      }
    } catch (err) {
      message.error("request failed");
      setLoadingCron(false);
    }
  };

  return (
    <>
      <Modal
        title={
          <Flex justify="flex-start" align="flex-start" className="model_title">
            <EditOutlined className="model_title_mr10" />
            <Typography.Title level={4} className="mg">
              Add Cron Job
            </Typography.Title>
          </Flex>
        }
        width="50%"
        open={visible}
        onCancel={() => {
          setVisible(false);
          form.resetFields();
        }}
        footer={
            <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button
            key="back"
            onClick={() => {
              setVisible(false);
              form.resetFields();
            }}
          >
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>}
        centered
      >
        <Flex justify="space-between" align="flex-start">
          <div className="model_top" style={{ width: "100%" }}>
            <div className="model_content">
              <Form
                {...layout}
                name="UpdateCronJobForm" 
                onFinish={onFinishAdd}
                form={form}
                // initialValues={{ userType: 1 }}
                labelCol={{
                  style: {
                    width: "150px",
                  },
                }}
                wrapperCol={{
                  style: {
                    flex: 1,
                  },
                }}
              >
                <Form.Item
                  name="taskName"
                  label="Task Name"
                  rules={[
                    {
                      required: true,
                      message: "Please fill in task name",
                    },
                  ]}
                >
                  <Input placeholder="Please fill in task name." allowClear />
                </Form.Item>

                <Form.Item
                  name="taskKey"
                  label="Task Key"
                  rules={[
                    { required: true, message: "Please select task key" },
                  ]}
                >
                  <Select
                    placeholder="Select work Task Type"
                    options={officeList}
                    onSearch={handleSearch}
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>

                <Form.Item
                  name="taskType"
                  label="Task Type"
                  rules={[
                    { required: true, message: "Please select task type" },
                  ]}
                >
                  <Select
                    placeholder="Select task type"
                    options={taskTypeKList}
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(value) => handleTaskTypeChange(value, form)}
                  />
                </Form.Item>

                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues.taskType !== currentValues.taskType
                  }
                >
                  {({ getFieldValue }) => {
                    const taskType = getFieldValue("taskType");

                    return (
                      <>
                        {/* CRON类型显示Cron相关字段 */}
                        {taskType === "CRON" && (
                          <>
                            <Form.Item
                              label={
                                <span>
                                  Cron Expression
                                  <span
                                    style={{ color: "#ff4d4f", marginRight: 4 }}
                                  >
                                    *
                                  </span>
                                  <QuestionCircleOutlined
                                    style={{
                                      marginLeft: 4,
                                      color: "#1890ff",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => setCronModalVisible(true)}
                                  />
                                </span>
                              }
                              style={{ marginBottom: 24 }}
                              required
                            >
                              <Space.Compact style={{ width: "100%" }}>
                                <Form.Item
                                  name="cronExpression"
                                  noStyle
                                  style={{ flex: 1 }}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter cron expression",
                                    },
                                  ]}
                                >
                                  <Input
                                    type="text"
                                    placeholder="Please enter Cron"
                                    allowClear
                                  />
                                </Form.Item>

                                <div style={{ flex: "0 0 auto" }}>
                                  <Button
                                    type="primary"
                                    loading={loadingCron}
                                    onClick={() => {
                                      const val = form
                                        .getFieldValue("cronExpression")
                                        ?.trim();
                                      if (val) cronData(val);
                                    }}
                                  >
                                    Search
                                  </Button>
                                </div>
                              </Space.Compact>
                            </Form.Item>

                            <Form.Item
                              label="Cron Remark"
                              style={{ marginBottom: 24 }}
                            >
                              <Form.Item name="cronResult" noStyle>
                                <Input
                                  type="text"
                                  placeholder="Result"
                                  allowClear
                                  disabled
                                />
                              </Form.Item>
                            </Form.Item>
                          </>
                        )}

                        {/* ONCE_AT类型显示Run At字段 */}
                        {taskType === "ONCE_AT" && (
                          <Form.Item
                            name="runAtMillis"
                            label="Run At."
                            style={{ marginBottom: 24 }}
                            rules={[
                              {
                                required: true,
                                message: "Please select run time",
                              },
                            ]}
                          >
                            <DatePicker
                              showTime
                              format="YYYY-MM-DD HH:mm:ss"
                              placeholder="Select date and time"
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        )}
                      </>
                    );
                  }}
                </Form.Item>
                <Form.Item name="enabled" label="Enabled">
                  <Select
                    placeholder="Select task type"
                    options={enabledList}
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>

                <Form.Item name="emailReceivers" label="Email Receivers">
                  <Select
                    placeholder="Select email"
                    mode="multiple"
                    options={emailList}
                    onSearch={handleEmailSearch}
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>

                <Form.Item name="emailContent" label="Email Content">
                  <Input placeholder="Please enter Email Content" allowClear />
                </Form.Item>
                <Form.Item name="emailSubject" label="Email Subject">
                  <Input placeholder="Please enter Email Content" allowClear />
                </Form.Item>
                <Form.Item name="id" hidden>
                  <Input />
                </Form.Item>
              </Form>
            </div>
          </div>
        </Flex>
      </Modal>
      <Modal
        title="Cron Expression Description"
        open={cronModalVisible}
        onCancel={() => setCronModalVisible(false)}
        width={800}
        footer={[
          <Button key="close" onClick={() => setCronModalVisible(false)}>
            Cancel
          </Button>,
        ]}
      >
        <div style={{ height: "500px" }}>
          <iframe
            src="/cron.html"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              borderRadius: "4px",
            }}
            title="Cron Expression Description"
          />
        </div>
      </Modal>
    </>
  );
});

export default UpdateModal;
